import { signInWithCustomToken, signOut } from 'firebase/auth';
import { auth } from './firebaseCore';
import { serverAxios } from '../config';

const FIREBASE_TOKEN_PATH = '/firebase-token';

export const signInToFirebaseWithWeb3Auth = async (web3AuthIdToken: string): Promise<void> => {
    if (!web3AuthIdToken) {
        throw new Error('Missing Web3Auth ID token');
    }

    const { data } = await serverAxios.post<{ customToken: string }>(FIREBASE_TOKEN_PATH, {
        idToken: web3AuthIdToken,
    });

    if (!data?.customToken) {
        throw new Error('Backend did not return a Firebase custom token');
    }

    await signInWithCustomToken(auth, data.customToken);
};

export const signOutFirebase = async (): Promise<void> => {
    if (auth.currentUser) {
        await signOut(auth);
    }
};
